
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
        activityWallet: state => state.player.activityWallet,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      })
    }
  }
